import { Component, Vue } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";
import Region from "@/models/Region";
import District from "@/models/District";
import Town from "@/models/Town";

export const GET_REGION = "get_region";
export const GET_DISTRICT = "get_district";
export const GET_TOWN = "get_town";

@Component
export default class LocalityMixin extends Vue {
  readonly regionUrl = BASE_API_URL + "regions";
  readonly districtUrl = BASE_API_URL + "districts";
  readonly townUrl = BASE_API_URL + "towns";

  async getRegions(): Promise<Region[]> {
    return await this.$httpGet(this.regionUrl, GET_REGION);
  }

  async getDistricts(regionId: string): Promise<District[]> {
    return await this.$httpGet(
      this.districtUrl + "?region_id=" + regionId,
      GET_DISTRICT
    );
  }

  async getTowns(districtId: string): Promise<Town[]> {
    return await this.$httpGet(
      this.townUrl + "?district_id=" + districtId,
      GET_TOWN
    );
  }
}
